import styled, {css} from 'styled-components'

import {List, Stack, Text, tokens} from '@pleo-io/telescope'
import {Check} from '@pleo-io/telescope-icons'

import {ScreenActionWrapper} from '@product-web/feature-ui/guides/guide.styles'

import {breakpoints} from 'styles/theme'

export const ActionWrapper = styled(ScreenActionWrapper)<{
    $justifyContent?: 'space-between' | 'end'
}>`
    justify-content: ${({$justifyContent}) => $justifyContent ?? 'end'};
`

export const CompactList = styled(List)`
    & > li {
        margin-bottom: 0;
    }
`

const circleStyles = css`
    box-sizing: border-box;
    height: 20px;
    width: 20px;
    border-radius: ${tokens.circle};
    flex-shrink: 0;
    margin-top: ${tokens.spacing2};
`

const CheckCircleIconWrapper = styled.div`
    ${circleStyles}
    display: grid;
    place-content: center;
    background-color: ${tokens.colorBackgroundPositive};
    color: ${tokens.colorContentStaticInverse};
`
export const CheckCircleIcon = () => (
    <CheckCircleIconWrapper>
        <Check size={16} />
    </CheckCircleIconWrapper>
)

export const EmptyCircleIcon = styled.div`
    ${circleStyles}
    border: ${tokens.sizeBorderDefault} solid ${tokens.colorBorderStaticLoud};
`

export const LinedThroughText = styled(Text)`
    text-decoration: line-through;
`
export const Illustration = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${tokens.spacing20};

    @media (max-width: ${breakpoints.tabletUp}) {
        padding: 0;

        img,
        svg {
            max-height: 100%;
            width: auto;
        }
    }

    img,
    svg {
        object-fit: contain;
        width: 100%;
        object-position: center;
    }
`

export const ContentWrapper = styled(Stack).attrs({space: 32})`
    @media (min-width: ${breakpoints.tabletUp}) {
        max-height: 400px;
        overflow: auto;
    }
`

export const Boldon = styled(Text).attrs({weight: 'bold', as: 'span'})``

export const DaysBreakdownPanel = styled.div`
    width: auto;
    padding: ${tokens.spacing16} ${tokens.spacing10};
    border-radius: ${tokens.arc8};
    border: ${tokens.borderPrimary};
    background-color: ${tokens.shade100};
`
